// extracted by css-extract-rspack-plugin
export default {"cls1":"Avatar-cls1_YwO","cls2":"Avatar-cls2_gp7 Avatar-cls1_YwO","small":"Avatar-small_Oq6"};